import React from 'react';

const Logo = () => (
  <img
    srcSet="https://res.cloudinary.com/dnl5kwhe6/image/upload/v1567563417/Quick_Credit/logo-sm_o2xdjf.png 1x, https://res.cloudinary.com/dnl5kwhe6/image/upload/v1567563417/Quick_Credit/logo-md_a1owld.png 2x"
    alt="Quick Credit logo"
    src="https://res.cloudinary.com/dnl5kwhe6/image/upload/v1567563417/Quick_Credit/logo-sm_o2xdjf.png"
    className="logo"
  />
);
export default Logo;
